import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const FormFields = ({
  fieldGroups,
  fieldValues,
  fieldLabels,
  currentDistricts,
  indianStates,
  months,
  daysOfWeek,
  relationTypes,
  years,
  onFieldChange
}) => {
  const renderField = (field) => {
    const label = fieldLabels[field] || field.replace(/_/g, ' ');
    
    // Date fields
    if (field.includes('Dob') || field.includes('DOB') || field.includes('LDOB') || 
        field === 'CDate' || field === 'DateINC') {
      return (
        <Input
          type="date"
          id={field}
          data-testid={`field-${field}`}
          value={fieldValues[field] || ''}
          onChange={(e) => onFieldChange(field, e.target.value)}
          className="h-10"
        />
      );
    }
    
    // State dropdown
    if (field === 'State') {
      return (
        <Select
          value={fieldValues[field] || 'Kerala'}
          onValueChange={(value) => onFieldChange(field, value)}
        >
          <SelectTrigger className="h-10" data-testid={`field-${field}`}>
            <SelectValue placeholder="Select State" />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {indianStates.map((state) => (
              <SelectItem key={state} value={state}>{state}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    
    // District dropdown
    if (field === 'BDistrict') {
      return (
        <Select
          value={fieldValues[field] || ''}
          onValueChange={(value) => onFieldChange(field, value)}
        >
          <SelectTrigger className="h-10" data-testid={`field-${field}`}>
            <SelectValue placeholder="Select District" />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {currentDistricts.map((district) => (
              <SelectItem key={district} value={district}>{district}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    
    // Month dropdown
    if (field === 'CMonth' || field === 'PMonth') {
      return (
        <Select
          value={fieldValues[field] || ''}
          onValueChange={(value) => onFieldChange(field, value)}
        >
          <SelectTrigger className="h-10" data-testid={`field-${field}`}>
            <SelectValue placeholder="Select Month" />
          </SelectTrigger>
          <SelectContent>
            {months.map((month) => (
              <SelectItem key={month} value={month}>{month}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    
    // Day dropdown
    if (field === 'CDay') {
      return (
        <Select
          value={fieldValues[field] || ''}
          onValueChange={(value) => onFieldChange(field, value)}
        >
          <SelectTrigger className="h-10" data-testid={`field-${field}`}>
            <SelectValue placeholder="Select Day" />
          </SelectTrigger>
          <SelectContent>
            {daysOfWeek.map((day) => (
              <SelectItem key={day} value={day}>{day}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    
    // Year dropdown
    if (field === 'CYear' || field === 'GD_YR') {
      return (
        <Select
          value={fieldValues[field] || ''}
          onValueChange={(value) => onFieldChange(field, value)}
        >
          <SelectTrigger className="h-10" data-testid={`field-${field}`}>
            <SelectValue placeholder="Select Year" />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {years.slice().reverse().map((year) => (
              <SelectItem key={year} value={year.toString()}>{year}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    
    // Relation dropdown
    if (field === 'MD_Relation') {
      return (
        <Select
          value={fieldValues[field] || ''}
          onValueChange={(value) => onFieldChange(field, value)}
        >
          <SelectTrigger className="h-10" data-testid={`field-${field}`}>
            <SelectValue placeholder="Select Relation" />
          </SelectTrigger>
          <SelectContent>
            {relationTypes.map((relation) => (
              <SelectItem key={relation} value={relation}>{relation}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    
    // Default text input
    return (
      <Input
        id={field}
        data-testid={`field-${field}`}
        value={fieldValues[field] || ''}
        onChange={(e) => onFieldChange(field, e.target.value)}
        placeholder={`Enter ${label.toLowerCase()}`}
        className="h-10"
      />
    );
  };

  return (
    <div className="space-y-8">
      {Object.entries(fieldGroups).map(([groupName, fields]) => (
        <div key={groupName}>
          <div className="flex items-center gap-2 mb-4">
            <h3 className="text-base font-semibold text-gray-900">{groupName}</h3>
            <div className="flex-1 h-px bg-gray-200"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {fields.map((field) => {
              const label = fieldLabels[field] || field.replace(/_/g, ' ');
              return (
                <div key={field}>
                  <Label htmlFor={field} className="text-sm font-medium text-gray-700 mb-1.5 block">
                    {label}
                  </Label>
                  {renderField(field)}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FormFields;
